module.exports = __webpack_public_path__ + "static/media/Frame 313.589de919.png";